module.exports = __webpack_public_path__ + "static/media/westmorlandlodge-photo.da9a06ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg/westmorlandlodge-photo.jpg
// module id = 5873
// module chunks = 0